import { hotItems } from '@/mocks/homeData';

const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-accent-500' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-foreground-400' },
  flat: { icon: 'ri-arrow-right-line', cls: 'text-foreground-400' },
};

const tagTone: Record<string, string> = {
  瓜料: 'bg-accent-100 text-accent-700',
  资讯: 'bg-secondary-100 text-secondary-900',
  合集: 'bg-primary-100 text-primary-700',
  素材: 'bg-background-200 text-foreground-700',
};

export default function HotRank() {
  const top = hotItems.slice(0, 3);
  const rest = hotItems.slice(3);

  return (
    <section id="hot" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-500">
              <i className="ri-fire-fill" /> 今日热榜
            </span>
            <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">
              91免费瓜料汇总<span className="text-accent-500">热榜</span>
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              按讨论热度与更新频率排序的 91免费瓜料汇总，Top 榜单项下直接看，追更不用再翻来翻去。
            </p>
          </div>
          <a
            href="#topics"
            className="inline-flex items-center gap-1 whitespace-nowrap self-start text-sm font-medium text-primary-600 hover:text-primary-700 md:self-auto"
          >
            进入话题墙 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="space-y-3">
            {top.map((item) => {
              const t = trendIcon[item.trend];
              return (
                <a
                  key={item.rank}
                  href="#feed"
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300 hover:bg-background-50"
                >
                  <span
                    className={`font-heading flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-2xl ${
                      item.rank === 1
                        ? 'bg-accent-500 text-background-50'
                        : item.rank === 2
                          ? 'bg-accent-400 text-background-50'
                          : 'bg-secondary-500 text-background-50'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-semibold text-foreground-950 group-hover:text-accent-700 md:text-base">
                      {item.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <i className={`${t.icon} ${t.cls}`} /> 热度 {item.heat}
                    </span>
                  </span>
                  <span
                    className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${tagTone[item.tag]}`}
                  >
                    {item.tag}
                  </span>
                </a>
              );
            })}
          </div>

          <div className="space-y-3">
            {rest.map((item) => {
              const t = trendIcon[item.trend];
              return (
                <a
                  key={item.rank}
                  href="#feed"
                  className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
                >
                  <span className="font-heading flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl text-foreground-500">
                    {item.rank}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700 md:text-base">
                      {item.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <i className={`${t.icon} ${t.cls}`} /> 热度 {item.heat}
                    </span>
                  </span>
                  <span
                    className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${tagTone[item.tag]}`}
                  >
                    {item.tag}
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}